export default "__VITE_ASSET__u3EjrE2t__"